import MySuppliersAll from './ThirdPartyManagementMySuppliers'
import MySuppliersEdit from './ThirdPartyManagementMySuppliersEdit'
import MySuppliersNew from './ThirdPartyManagementMySuppliersNew'
import MySuppliersShow from './ThirdPartyManagementMySuppliersShow'
import PreAvaliation from './ThirdPartyManagementPreAvaliation'
import QuestionnairesReceived from './ThirdPartyManagementQuestionnairesReceived'
import Suggestion from './ThirdPartyManagementSuggestion'
import MySuppliersAuditNew from './ThirdPartyManagementMySuppliersAuditNew'
import MySuppliersAuditEdit from './ThirdPartyManagementMySuppliersAuditEdit'
import MySuppliersAuditShow from './ThirdPartyManagementMySuppliersAuditShow'

export default {
  MySuppliers: {
    All: MySuppliersAll,
    AuditNew: MySuppliersAuditNew,
    AuditEdit: MySuppliersAuditEdit,
    AuditShow: MySuppliersAuditShow,
    New: MySuppliersNew,
    Show: MySuppliersShow,
    Edit: MySuppliersEdit,
  },
  QuestionnairesReceived,
  PreAvaliation,
  Suggestion,
}
